import type { ThemeSpec } from '../themes';

/**
 * Empty-board invitation watermark — the canvas should not greet a first
 * visitor with literally nothing (R4-D-14 / Domain D2-9).
 * pointer-events:none so it never intercepts the first stroke.
 */
export function EmptyBoardWatermark({ theme }: { theme: ThemeSpec }) {
  return (
    <div
      aria-hidden
      className="absolute inset-0 z-10 pointer-events-none flex flex-col items-center justify-center select-none"
    >
      <div
        className="text-center font-hand"
        style={{ color: theme.surfaceTextMuted, opacity: 0.7 }}
      >
        <div className="text-[28px] tracking-wide">这块黑板还空着</div>
        <div className="mt-2 text-[15px]">第一笔由你写下</div>
      </div>
    </div>
  );
}
